module.exports = __webpack_public_path__ + "img/bdsq.94335b8a.png";